import { render, staticRenderFns } from "./TicketStatus.vue?vue&type=template&id=33f4b1ba&"
import script from "./TicketStatus.vue?vue&type=script&lang=js&"
export * from "./TicketStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports